import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export default function PendingPage() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full border rounded-xl p-8 bg-[hsl(var(--card))]" style={{ borderColor: 'hsl(var(--border))' }} data-testid="pending-screen">
        <div className="w-10 h-10 rounded-full flex items-center justify-center mb-4" style={{ background: 'hsl(var(--accent))' }}>
          <CheckCircle2 size={20} color="hsl(var(--accent-foreground))" />
        </div>
        <h2 className="font-heading text-xl font-semibold">Account received.</h2>
        <p className="mt-1 text-[14px] text-[hsl(var(--foreground-muted))]">
          Hi {user?.name?.split(' ')[0]} — an admin needs to assign your role before you can access the workspace. You'll be notified as soon as that's done.
        </p>
        <div className="mt-4 border-t pt-4 flex gap-2" style={{ borderColor: 'hsl(var(--border))' }}>
          <Button variant="outline" onClick={() => { logout(); nav('/login'); }} data-testid="pending-signout">Sign out</Button>
        </div>
      </div>
    </div>
  );
}
